import { render, staticRenderFns } from "./StaffTable.vue?vue&type=template&id=2a46baa6&"
import script from "./StaffTable.vue?vue&type=script&lang=js&"
export * from "./StaffTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a46baa6')) {
      api.createRecord('2a46baa6', component.options)
    } else {
      api.reload('2a46baa6', component.options)
    }
    module.hot.accept("./StaffTable.vue?vue&type=template&id=2a46baa6&", function () {
      api.rerender('2a46baa6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/organization/staffs/StaffTable.vue"
export default component.exports